module.exports = __webpack_public_path__ + "static/media/gnj-profile-pic.e2ee9f99.svg";